const arr = (v) => (Array.isArray(v) ? v : v ? [v] : []);

export const FILTERS = {
  school: [
    { key: "category", label: "Category", get: (i) => arr(i.category) },
    { key: "level", label: "Level", get: (i) => (i.levels?.length ? i.levels : arr(i.level)) },
    { key: "country", label: "Country", get: (i) => arr(i.countries) },
    { key: "city", label: "City", get: (i) => arr(i.cities) },
  ],
  program: [
    { key: "school", label: "School", get: (i) => arr(i.school) },
    { key: "level", label: "Level", get: (i) => (i.levels?.length ? i.levels : arr(i.level)) },
    { key: "language", label: "Language", get: (i) => arr(i.languages) },
    { key: "attendance", label: "Study mode", get: (i) => arr(i.attendance) },
    { key: "country", label: "Country", get: (i) => arr(i.countries) },
    { key: "city", label: "City", get: (i) => arr(i.cities) },
  ],
};

const years = (d) => {
  const m = /(\d+(?:[.,]\d+)?)\s*(month|mois)?/i.exec(d || "");
  if (!m) return null;
  const n = parseFloat(m[1].replace(",", "."));
  return m[2] ? n / 12 : n;
};
const nullsLast = (a, b, dir = 1) => (a == null ? 1 : b == null ? -1 : (a - b) * dir);

export const SORTS = {
  school: [
    { key: "default", label: "Default order" },
    { key: "az", label: "Name A → Z" },
    { key: "score", label: "Best score" },
    { key: "ranking", label: "Best ranking" },
  ],
  program: [
    { key: "default", label: "Default order" },
    { key: "az", label: "Name A → Z" },
    { key: "duration_asc", label: "Shortest duration" },
    { key: "duration_desc", label: "Longest duration" },
  ],
};

const SORT_FN = {
  az: (a, b) => a.title.localeCompare(b.title),
  score: (a, b) => nullsLast(parseFloat(a.score) || null, parseFloat(b.score) || null, -1),
  ranking: (a, b) => nullsLast(parseInt(a.ranking, 10) || null, parseInt(b.ranking, 10) || null),
  duration_asc: (a, b) => nullsLast(years(a.duration), years(b.duration)),
  duration_desc: (a, b) => nullsLast(years(a.duration), years(b.duration), -1),
};

export const emptyState = () => ({ q: "", sel: {}, minScore: 0, sort: "default" });

export function optionsFor(items, filter) {
  const counts = {};
  items.forEach((i) => filter.get(i).forEach((v) => { counts[v] = (counts[v] || 0) + 1; }));
  return Object.entries(counts).sort((a, b) => a[0].localeCompare(b[0]));
}

export function applyFilters(items, state, type) {
  const q = state.q.trim().toLowerCase();
  const out = items.filter((i) => {
    if (q && ![i.title, i.subtitle, i.school, i.location, i.category].some((v) => v && v.toLowerCase().includes(q))) return false;
    if (state.minScore && !(parseFloat(i.score) >= state.minScore)) return false;
    return FILTERS[type].every((f) => {
      const chosen = state.sel[f.key] || [];
      return !chosen.length || f.get(i).some((v) => chosen.includes(v));
    });
  });
  const fn = SORT_FN[state.sort];
  return fn ? [...out].sort(fn) : out;
}
